module.exports = __webpack_public_path__ + "static/img/irole.0311f81.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/mobile_img/role3/lxx/irole.png
// module id = C9sl
// module chunks = 7